<template>
    <label class="flex flex-col" :class="margins">
        <span class="flex flex-row items-center gap-2">
            <span class="capitalize font-semibold" :class="fontSize"><slot>{{ $t("Label") }} </slot></span>
            <vx-tooltip v-if="info" :text="info" position="top" class="h-3 mb-2">
                <vs-icon icon="help" round bg="white" color="primary"></vs-icon>
            </vx-tooltip>
        </span>
        <span v-if="extra" class="text-sm font-thin"> {{ extra }} </span>
    </label>
</template>

<script>
export default {
    name: 'label-form',
    props: {
        info: String,
        extra: String,
        fontSize: {
            type: String,
            default: 'text-base'
        },
        margins: {
            type: String,
            default: 'mt-8'
        }
    }
}
</script>

<style>
    .con-vs-tooltip {
        @apply inline-block
    }
</style>
